import { IonAccordion, IonAccordionGroup, IonButton, IonButtons, IonCard, IonCardContent, IonCheckbox, IonChip, IonCol, IonContent, IonDatetime, IonDatetimeButton, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonModal, IonPage, IonProgressBar, IonRow, IonSelect, IonSelectOption, IonSkeletonText, IonSpinner, IonText, IonTextarea, IonTitle, IonToolbar, useIonLoading, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import { alarmOutline, alertCircleOutline, arrowBack, arrowUpCircleOutline, caretForwardCircleOutline, checkmarkCircleOutline, chevronBackOutline, globeOutline, helpCircleOutline, time, timerOutline, warningOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import { useLocation, useParams } from 'react-router-dom';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { subMinutes, addMinutes, addHours, addWeeks } from 'date-fns';
import TimerProgressBar from '../components/TimerProgressBar';
import { useCountdownTimer } from '../components/CountdownTimer';

interface RouteParams {
    token: string;
}

const TimerEdit: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [present, dismiss] = useIonLoading();

    const [timer, setTimer] = useState<any>({});
    const [typeSetting, setTypeSetting] = useState<string>('');
    const [place, setPlace] = useState<string>('');
    const [route, setRoute] = useState<string>('');
    const [routeType, setRouteType] = useState<string>('');
    const [timerName, setTimerName] = useState<string>('');
    const [timerTimezone, setTimerTimezone] = useState<string>('');
    const [placeDST, setPlaceDST] = useState<string>('');
    const [todayIsDST, setTodayIsDST] = useState<boolean>(false); 
    const [timerDST, setTimerDST] = useState<boolean>(false);
    const [timerStartTimeISO, setTimerStartTimeISO] = useState<string>('');
    const [timerEndTimeISO, setTimerEndTimeISO] = useState<string>('');
    const [startTime, setStartTime] = useState<number>(0);
    const [endTime, setEndTime] = useState<number>(0);
    const [alarmDelay, setAlarmDelay] = useState<any>();  
    const [timesValid, setTimesValid] = useState<boolean>(true);
    const [timerDuration, setTimerDuration] = useState<string>('');

    const [partySize, setPartySize] = useState<string>('0');
    const [partnerText, setPartnerText] = useState<string>('');
    const [selectedPartnerTokens, setSelectedPartnerTokens] = useState<any[]>([]);
    const [selectedPartnerEmails, setSelectedPartnerEmails] = useState<any[]>([]);
    const [selectedKids, setSelectedKids] = useState<any[]>([]);
    const [selectedPets, setSelectedPets] = useState<any[]>([]);
    const [activity, setActivity] = useState<string>('');
    const [equipment, setEquipment] = useState<any[]>([]); 
    const [checkedEquipment, setCheckedEquipment] = useState<any[]>([]); 
    const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
    const [madeChanges, setMadeChanges] = useState<boolean>(false);
    
    const contentRef = useRef<HTMLIonContentElement | null>(null);
    const formRef = useRef<HTMLFormElement>(null);
    const placeRef = useRef<any>();
    const routeRef = useRef<any>();
    const startDateRef = useRef<any>('');
    const timerDSTOverrrideRef = useRef<any>();
    const location = useLocation();

    const { networkStatus, getAppStatus, authKey, authorizedMember, authenticateMember, level, limits, profiles, settings, places, getPlaces, routes, getRoutes, activePartners, getPartnerships, availableKids, setAvailableKids, kids, getKids, availablePets, setAvailablePets, pets, getPets, vehicles, getVehicles, vehiclesAll, setVehiclesAll, vehiclesStart, setVehiclesStart, vehiclesEnroute, setVehiclesEnroute, vehiclesEnd, setVehiclesEnd, selectedVehiclesStart, setSelectedVehiclesStart, selectedVehiclesEnroute, setSelectedVehiclesEnroute, selectedVehiclesEnd, setSelectedVehiclesEnd, contacts, availableContacts, setAvailableContacts, getContacts, checkedContacts, setCheckedContacts, textLogoLoaded, fadeInTextLogo, SWFullHorizLogo, SWTextDarkLogo, timezones, timezonesIANA, now, getTimezones, getTimezonesIANA, userTimezone, timezoneName } = useAppContext();
        
    const [showToast] = useIonToast();
    const { token } = useParams<RouteParams>();
    const router = useIonRouter();
    const { updateCountdownEnd, stopCountdown } = useCountdownTimer();

    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();   
                if (!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 


    useIonViewDidLeave(() => {
        setTimerStartTimeISO('');
        setTimerEndTimeISO('')
    });


    useEffect(() => {
        if (limits.places > 0) {
            const fetchData = async () => {
                setTodayIsDST(checkDST());
                //setTimerDST(checkDST());
                await getPlaces(authorizedMember.memberToken, limits.places);
                await getRoutes(authorizedMember.memberToken, limits.routes);
                await getTimezones(authorizedMember.memberToken);
                await getTimezonesIANA(authorizedMember.memberToken);
                await getPartnerships(authorizedMember.memberToken, 'all');
                await getKids(authorizedMember.memberToken, limits.kids);
                await getPets(authorizedMember.memberToken, limits.pets);
                await getVehicles(authorizedMember.memberToken, limits.vehicles);
                await getContacts(authorizedMember.memberToken, 'active', limits.contacts);
                await getEquipment(authorizedMember.memberToken);
                await getTimer(token);
                setLoading(false);
                if (location.hash) setTimeout(() => scrollToHash(), 500); 
            }
            fetchData();
        }
    }, [authorizedMember, limits]);


    useEffect(() => {
        const startTimeObj = new Date(timerStartTimeISO);
        const startTimeMs = startTimeObj.getTime();
        let startTimeUNIX = Math.floor(startTimeMs / 1000);
        const tzOffset = parseInt(timerTimezone) * 3600;
        startTimeUNIX = startTimeUNIX + tzOffset;
        if(todayIsDST) startTimeUNIX = startTimeUNIX + 3600;
        setStartTime(startTimeUNIX); 
    }, [timerStartTimeISO]); 

    
    useEffect(() => {
        const endTimeObj = new Date(timerEndTimeISO);
        const endTimeMs = endTimeObj.getTime();
        let endTimeUNIX = Math.floor(endTimeMs / 1000);
        const tzOffset = parseInt(timerTimezone) * 3600;
        endTimeUNIX = endTimeUNIX + tzOffset;
        if(todayIsDST) endTimeUNIX = endTimeUNIX + 3600;
        setEndTime(endTimeUNIX);
    }, [timerEndTimeISO]);  


    useEffect(() => {
        getPartnerships( authKey.mt, 'all' );        
    }, [timer]);


    useEffect(() => {
        selectedPartnerTokens.forEach((token: any, index: number, arr: any) => {
            getInitPartnerObjects(token);
        });              
    }, [activePartners]);


    useEffect(() => {
        if(timer.delay !== undefined) setAlarmDelay(timer.delay);        
        dismiss();
    }, [timer]);


    /*useEffect(() => {
        initializeDates();
    }, [startTime, endTime]); */ //timer


    useEffect(() => {
        if(startDateRef.current !== undefined) validateForm();
    }, [checkedContacts, timer]); 


    const scrollToHash = async () => {
        const id = location.hash.slice(1);
        const target = document.getElementById(id);

        if (!target || !contentRef.current) return;
        
        const scrollEl = await contentRef.current.getScrollElement();
        const offset =
        target.getBoundingClientRect().top
        - scrollEl.getBoundingClientRect().top
        + scrollEl.scrollTop;

        scrollEl.scrollTo({ top: offset, behavior: "smooth" });        
    };
      

    const getTimer = async (tt: string) => {
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('tt', tt);
            const response = await fetch('https://api.besolowise.com/timers/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();
                //console.log(obj);
                if(typeof obj.id === 'number') {
                    if(obj.status === '2') {
                        dismiss();
                        router.push('/account/timer/view/' + tt, 'back'); 
                        return false;
                    } else {
                        //console.log(obj);
                        setTimerName(obj.name);
                        setTypeSetting(obj.routeToken == '' ? 'STATIONARY' : 'MOBILE');
                        setPlace(obj.startPlaceToken);
                        setRoute(obj.routeToken);
                        setRouteType(obj.routeType);

                        setTimerStartTimeISO(obj.startTimeISO);
                        setTimerEndTimeISO(obj.endTimeISO);

                        await initializeDates(obj.startTimeISO, obj.endTimeISO);

                        setStartTime(obj.startTime); 
                        setEndTime(obj.endTime); 
                        let startTimeHour = obj.startTimeArr[1];
                        if(parseInt(startTimeHour) > 12) {
                            startTimeHour = (parseInt(startTimeHour) - 12).toString();
                            if(parseInt(startTimeHour) < 10) startTimeHour = '0' + startTimeHour;
                        }
                        
                        let endTimeHour = obj.endTimeArr[1];
                        if(parseInt(endTimeHour) > 12) {
                            endTimeHour = (parseInt(endTimeHour) - 12).toString();
                            if(parseInt(endTimeHour) < 10) endTimeHour = '0' + endTimeHour;
                        }
                        
                        setTimerTimezone(obj.ianaTimezone);
                        setPlaceDST(obj.endPlaceDST);
                        setTimerDST(obj.endDST == '1');
                        setPartySize(obj.partySize.toString());
                        setPartnerText(obj.partnerText);
                        setSelectedPartnerTokens(obj.partnerTokens);
                        setSelectedPartnerEmails(obj.partnerEmails);
                        setCheckedContacts(obj.contactTokens);
                        setSelectedKids(obj.kidTokens);
                        setSelectedPets(obj.petTokens);
                        setSelectedVehiclesStart(obj.vehicleStartTokens);
                        setSelectedVehiclesEnroute(obj.vehicleEnrouteTokens);
                        setSelectedVehiclesEnd(obj.vehicleEndTokens);
                        setActivity(obj.activity);
                        setCheckedEquipment(obj.equipmentIDs);
                        setTimer(obj); 

                        return obj;
                        
                    }
                } else {
                    setLoading(false);
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                        position: 'bottom'
                    });
                }
            } else {
                setLoading(false);
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom'
                });
            }
        } catch(error) {
            setLoading(false);
            showToast({
                message: 'Connection Error 1: ' + error + '.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        }       
    };


    /*const toggleTypeSetting = (e: any) => {
        //placeRef.current.value = '';
        //routeRef.current.value = '';
        setPlace('');
        setPlaceDST('');
        setTimerTimezone('');
        setRoute('');
        setRouteType('');
        setTypeSetting(e.detail.value);
    };*/
    

    const getTimezone = async (e: CustomEvent) => {
        const prt = e.detail.value; 

        try {
            const response = await fetch('https://api.besolowise.com/timers/get/?tz=' + encodeURIComponent(prt), {
                method: 'GET',
                credentials: 'include'
            });

            if(response.ok) {   
                const obj = await response.json();  
                setTodayIsDST(checkDST()); // ???
                setTimerTimezone(obj.timerTimezone);
                setPlaceDST(obj.placeUsesDST);
                //setTimerDST(obj.placeUsesDST == '2' ? true : false);
                setRouteType(obj.routeType);
                if(timerName == '') setTimerName(obj.routeName !== undefined ? obj.routeName : 'At '+obj.placeName);                
            } else {
                setLoading(false);
                showToast({
                    message: 'Response Error.',
                    duration: 3000,
                    color: 'danger',
                    position: 'bottom'
                });
            }
        } catch(error) {
            setLoading(false);
            showToast({
                message: 'Connection Error 2: ' + error + '.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        } 
    };


    const handleTimezoneChange = (e: CustomEvent) => {
        setTimerTimezone(e.detail.value);
        setMadeChanges(true);
    };


    const checkDST = () => {
        const now = new Date();
        const januaryOffset = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
        const julyOffset = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();    
        return now.getTimezoneOffset() !== januaryOffset;
    };


    /*const handleTimerDSTChange = (e: CustomEvent) => {
        setTimerDST(e.detail.checked);
        setPlaceDST(e.detail.checked ? '2' : '0');
        setMadeChanges(true);
    };*/


    const getLocaleDateStr = (datetime: Date) => {
        return datetime.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric' });        
    };


    const getLocaleDateStrShort = (datetime: Date) => {
        const year = datetime.getFullYear();
        const month = String(datetime.getMonth() + 1).padStart(2, '0');
        const day = String(datetime.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    //
    // Parse time periods
    //
    const parseTimePeriod = async (periodSecs: number, displaySecs: boolean, round: string) => {
        const oneMinute = 60; // seconds
        const oneHour   = 60 * oneMinute;
        const oneDay    = 24 * oneHour;
        const oneWeek   = 7 * oneDay;

        let periodStr = '';
        let periodWeeksRem = 0;
        let periodDaysRem = 0;
        let periodHoursRem = 0;
        let periodMinsRem = 0;

        if(periodSecs >= oneWeek) {
            let periodWeeksDec = periodSecs / oneWeek;
            let periodWeeksInt = Math.floor(periodWeeksDec);
            periodWeeksRem = (periodWeeksDec - periodWeeksInt) * oneWeek;
            periodStr = periodWeeksInt.toString() + ' wk';
            if(periodWeeksInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodWeeksRem);
        }
        
        if(periodSecs >= oneDay) {
            let periodDaysDec = periodSecs / oneDay;
            let periodDaysInt = Math.floor(periodDaysDec);
            periodDaysRem = (periodDaysDec - periodDaysInt) * oneDay;
            periodStr = periodStr + ' ' + periodDaysInt.toString() + ' day';
            if(periodDaysInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodDaysRem);
        }
        
        if(periodSecs >= oneHour) {
            let periodHoursDec = periodSecs / oneHour;
            let periodHoursInt = Math.floor(periodHoursDec);
            periodHoursRem = (periodHoursDec - periodHoursInt) * oneHour;
            periodStr = periodStr + ' ' + periodHoursInt.toString() + ' hr';
            if(periodHoursInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodHoursRem);
        }
        
        if(periodSecs >= oneMinute) {
            let periodMinutesDec = periodSecs / oneMinute;            
            let periodMinutesInt = round == 'ceil' ? Math.ceil(periodMinutesDec) : Math.floor(periodMinutesDec);
            periodMinsRem = (periodMinutesDec - periodMinutesInt) * oneMinute;
            if(periodMinutesInt == 60) periodMinutesInt = 59;
            periodStr = periodStr + ' ' + periodMinutesInt.toString() + ' min';
            if(periodMinutesInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodMinsRem);
        } else if(periodSecs < oneMinute && periodStr == '') {
            periodStr = periodStr + ' < 1 min';
        }

        if (displaySecs) {
            if(periodSecs >= 1) {
                periodStr = periodStr + ' ' + periodSecs.toString() + ' sec';
            } else if(periodSecs == 0) {
                periodStr = periodStr + ' 00 sec'
            }
        }

        return periodStr;
    };


    //
    // Initialize Start and End Times
    //
    const initializeDates = async (startTimeISO:string, endTimeISO:string) => { 
       
        // Begin calculating Starting Date and Time
        const nowDate = new Date();
        const nowTime = nowDate.getTime()
 
        // Set some variables based on the saved Timer data
        const timerStartDate = new Date(startTimeISO);
        const timerStartTime = timerStartDate.getTime();

        const timerEndDate = new Date(endTimeISO);
        const timerEndTime = timerEndDate.getTime();

        const durationSec = Math.abs(timerEndTime - timerStartTime) / 1000;
        const durationStr = await parseTimePeriod(durationSec, false, 'floor');
        setTimerDuration(durationStr); 
    };
    

    //
    // Handle changes in the Date and Time selections
    //
    const handleStartTimeISOChange = async (e: CustomEvent) => {
        const startTimeISO = e.detail.value as string;
        const startTime = new Date(startTimeISO).getTime();
        setStartTime(startTime);
        setTimerStartTimeISO(startTimeISO);
        setMadeChanges(true);      
        await initializeDates(startTimeISO, timerEndTimeISO);  
    };

    const handleEndTimeISOChange = async (e: CustomEvent) => {
        const endTimeISO = e.detail.value as string;
        const endTime = new Date(endTimeISO).getTime();
        setEndTime(endTime);
        setTimerEndTimeISO(endTimeISO);
        setMadeChanges(true);  
        await initializeDates(timerStartTimeISO, endTimeISO); 
    };


    //
    // Validate Time Selection Sequence
    //
    const validateTimes = () => { 
        let validTimesOrder = true;
        validTimesOrder = checkTimesOrder(0, 0);
        setTimesValid(validTimesOrder);
        return validTimesOrder;
    };


    //
    // Validate Start Time is BEFORE End time
    //
    const checkTimesOrder = (selStartTimeStamp: number, selEndTimeStamp: number) => {
        let rtn = true;        
        let currStartDateTimeStr = '';
        let currEndDateTimeStr = '';

        if(selStartTimeStamp === 0 && selEndTimeStamp === 0) {
        
        }
        return rtn;
    };


    //
    // Handle change of Timer Alarm Delay
    //
    const handleAlarmDelayChange = (e: CustomEvent) => {
        setAlarmDelay(e.detail.value);
        setMadeChanges(true);
    };


    //
    // Handle change of Activity
    //
    const handleActivityChange = (e: CustomEvent) => {
        setActivity(e.detail.value);
        setMadeChanges(true);
    };


    //
    // Handle change of Party Size
    //
    const handlePartySizeChange = (e: CustomEvent) => {
        const newPartySize = e.detail.value; 
        setPartySize(newPartySize);
        if(newPartySize == '0') removePartnerObjects();
        setMadeChanges(true);
    };


    //
    // Handle change of Partner Text
    //
    const handlePartnerTextChange = (e: CustomEvent) => {
        setPartnerText(e.detail.value);
        setMadeChanges(true);
    };
    

    //
    // Handle change of Pet selections
    //
    const handlePetSelect = (e: CustomEvent) => {        
        const pt = e.detail.value; 
        const checked = e.detail.checked;        
        let selPets = selectedPets;

        if(checked) {
            selPets.push(pt);
        } else {
            const tokenIndex = selPets.indexOf(pt);
            const xT = selPets.splice(tokenIndex, 1);
        }
        setSelectedPets(selPets);  
        setMadeChanges(true);  
    };


    //
    // Handle change of Kid selections
    //
    const handleKidSelect = (e: CustomEvent) => {        
        const kt = e.detail.value; 
        const checked = e.detail.checked;        
        let selKids = selectedKids;

        if(checked) {
            selKids.push(kt);
        } else {
            const tokenIndex = selKids.indexOf(kt);
            const xT = selKids.splice(tokenIndex, 1);
        }
        setSelectedKids(selKids);  
        setMadeChanges(true);  
    };


    const handleEquipmentSelect = (e: CustomEvent, eqid: number) => {        
        const eid = e.detail.value; 
        const checked = e.detail.checked;        
        let checkedEquip = checkedEquipment;

        //console.log(e, checked, eid, checkedEquip);

        if(checked) {
            checkedEquip.push(eid.toString());
        } else {
            const idIndex = checkedEquip.indexOf(eid);
            const xID = checkedEquip.splice(idIndex, 1);
        }

        setCheckedEquipment(() => checkedEquip);  
        setMadeChanges(true);  
    };
    

    //
    // Comparative function
    const isEqual = (obj1: any, obj2: any) => {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };


    //
    // Get or Remove each Partner's associated objects as the Partner is selected
    //
    const getInitPartnerObjects = async (pt: string) => { 
        
        let selPartnerTokens = [...selectedPartnerTokens];
        let selPartnerEmails = [...selectedPartnerEmails]
         
        // Fill array of all contactEmails        
        let contactEmails: any = [];
        availableContacts.forEach((item:any, index:number, arr:any) => {
            contactEmails.push(item.contactEmail);
        }); 

        try {
            const formData = new FormData();
            formData.append('pt', pt);
            formData.append('mt', authKey.mt);
            const response = await fetch('https://api.besolowise.com/partners/objects/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {   
                const obj = await response.json();  

                // Handle Kids array
                //
                let newKids;
                const partnerKids = Object.values(obj.kids);                
                newKids = [...kids];
                partnerKids.forEach((item:any, index:number, arr:any) => {
                    newKids.push(item);
                });                
                setAvailableKids(newKids);
                

                // Handle Pets array
                //
                let newPets;
                const partnerPets = Object.values(obj.pets);                
                newPets = [...pets];
                partnerPets.forEach((item:any, index:number, arr:any) => {
                    newPets.push(item);
                });                                
                setAvailablePets(newPets);


                // Handle Vehicles array
                //
                let newVehicles;
                let selVehiclesStart = selectedVehiclesStart;
                let selVehiclesEnroute = selectedVehiclesEnroute;
                let selVehiclesEnd = selectedVehiclesEnd;

                let newVehiclesStart: any = [];
                let newVehiclesEnroute: any = [];
                let newVehiclesEnd: any = [];
                const partnerVehicles = Object.values(obj.vehicles);
                
                newVehicles = [...vehiclesAll];
                partnerVehicles.forEach((item:any, index:number, arr:any) => {
                    if(vehiclesAll.some((obj:any) => isEqual(obj, item)) !== true) newVehicles.push(item);
                });

                
                // Re-sort and set
                newVehicles.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
                setVehiclesAll(newVehicles);

                newVehicles.forEach((item:any, index:number, arr:any) => {
                    if(selVehiclesStart.indexOf(item.vehicleToken) >= 0 || (selVehiclesEnroute.indexOf(item.vehicleToken) < 0 && selVehiclesEnd.indexOf(item.vehicleToken) < 0)) newVehiclesStart.push(item);
                });
                setVehiclesStart(newVehiclesStart);
        
                newVehicles.forEach((item:any, index:number, arr:any) => {
                    if(selVehiclesEnroute.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0)) newVehiclesEnroute.push(item);
                });
                setVehiclesEnroute(newVehiclesEnroute);
        
                newVehicles.forEach((item:any, index:number, arr:any) => {
                    if(selVehiclesEnd.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0)) newVehiclesEnd.push(item);
                });
                newVehiclesEnd.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
                setVehiclesEnd(newVehiclesEnd); 
                

                // Handle Contacts array
                //
                let newContacts: any = [];
                const partnerContacts = Object.values(obj.contacts);                
                
                // Contacts list cannot contain Self or a Selected Partner
                availableContacts.forEach((item:any, index:number, arr:any) => {
                    if(selPartnerEmails.indexOf(item.contactEmail) < 0 && item.contactEmail != authorizedMember.memberEmail) newContacts.push(item);
                });
                
                // Partner's Contacts cannot contain Self (primary user) or duplicates of Contacts
                partnerContacts.forEach((item:any, index:number, arr:any) => {
                    if(selPartnerEmails.indexOf(item.contactEmail) < 0 && 
                        contactEmails.indexOf(item.contactEmail) < 0 && 
                        item.contactEmail != authorizedMember.memberEmail 
                        ) newContacts.push(item);
                });
                
                // Re-sort and set availableContacts
                newContacts.sort((a: any, b: any) => (a.contactLastName > b.contactLastName) ? 1 : ((b.contactLastName > a.contactLastName) ? -1 : 0))
                setAvailableContacts(newContacts);

            } else {
                setLoading(false);
                showToast({
                    message: 'Response Error. Refresh this page to try again.',
                    duration: 3000,
                    color: 'danger',
                    position: 'bottom'
                });
            }
        } catch(error) {
            setLoading(false);
            showToast({
                message: 'Connection Error 3: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        }
    
        
    };

    //
    // Get or Remove each Partner's associated objects as the Partner is selected
    //
    const getPartnerObjects = async (e: CustomEvent) => {
        let em = '';
        const pt = e.detail.value; 
        const checked = e.detail.checked;

        // Get selected Partner Email
        activePartners.forEach((item:any, index:number, arr:any) => {
            if(item.token == pt) em = item.email;
        }); 
        
        // Fill array of all contactEmails        
        let contactEmails: any = [];
        availableContacts.forEach((item:any, index:number, arr:any) => {
            contactEmails.push(item.contactEmail);
        });      

        // Keep track of selected Partners, primarily for conditional Contacts
        let selPartnerTokens = selectedPartnerTokens;
        let selPartnerEmails = selectedPartnerEmails;
        if(checked) {
            selPartnerTokens.push(pt);
            selPartnerEmails.push(em);
        } else {
            const emailIndex = selPartnerEmails.indexOf(em);
            const tokenIndex = selPartnerTokens.indexOf(pt);
            const xE = selPartnerEmails.splice(emailIndex, 1);
            const xT = selPartnerTokens.splice(tokenIndex, 1);
        }
        setSelectedPartnerTokens(selPartnerTokens);
        setSelectedPartnerEmails(selPartnerEmails);

        try {
            const formData = new FormData();
            formData.append('pt', pt);
            formData.append('mt', authKey.mt);
            const response = await fetch('https://api.besolowise.com/partners/objects/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {   
                const obj = await response.json();  

                // Handle Kids array
                //
                let newKids;
                const partnerKids = Object.values(obj.kids);
                if(checked) {
                    newKids = [...availableKids];
                    partnerKids.forEach((item:any, index:number, arr:any) => {
                        newKids.push(item);
                    });
                } else {
                    newKids = availableKids.filter( function( item:any ) {
                        return !partnerKids.some(obj => isEqual(obj, item));
                    } );
                } 
                setAvailableKids(newKids);
                

                // Handle Pets array
                //
                let newPets;
                const partnerPets = Object.values(obj.pets);
                if(checked) {
                    newPets = [...availablePets];
                    partnerPets.forEach((item:any, index:number, arr:any) => {
                        newPets.push(item);
                    });
                } else {
                    newPets = availablePets.filter( function( item: any ) {
                        return !partnerPets.some(obj => isEqual(obj, item));
                    } );
                }                    
                setAvailablePets(newPets);


                // Handle Vehicles array
                //
                let newVehicles;
                let selVehiclesStart = selectedVehiclesStart;
                let selVehiclesEnroute = selectedVehiclesEnroute;
                let selVehiclesEnd = selectedVehiclesEnd;

                let newVehiclesStart: any = [];
                let newVehiclesEnroute: any = [];
                let newVehiclesEnd: any = [];
                const partnerVehicles = Object.values(obj.vehicles);

                if(checked) {
                    newVehicles = [...vehiclesAll];
                    partnerVehicles.forEach((item:any, index:number, arr:any) => {
                        newVehicles.push(item);
                    });
                } else {
                    newVehicles = vehiclesAll.filter( function( item: any ) {
                        return !partnerVehicles.some(obj => isEqual(obj, item));
                    } );
                }

                // Re-sort and set
                newVehicles.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
                setVehiclesAll(newVehicles);

                newVehicles.forEach((item:any, index:number, arr:any) => {
                    if(selVehiclesStart.indexOf(item.vehicleToken) >= 0 || (selVehiclesEnroute.indexOf(item.vehicleToken) < 0 && selVehiclesEnd.indexOf(item.vehicleToken) < 0)) newVehiclesStart.push(item);
                });
                setVehiclesStart(newVehiclesStart);
        
                newVehicles.forEach((item:any, index:number, arr:any) => {
                    if(selVehiclesEnroute.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0 && selVehiclesEnd.indexOf(item.vehicleToken) < 0)) newVehiclesEnroute.push(item);
                });
                setVehiclesEnroute(newVehiclesEnroute);
        
                newVehicles.forEach((item:any, index:number, arr:any) => {
                    if(selVehiclesEnd.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0 && selVehiclesEnroute.indexOf(item.vehicleToken) < 0)) newVehiclesEnd.push(item);
                });
                setVehiclesEnd(newVehiclesEnd); 


                // Handle Contacts array
                //    
                let newContacts: any = [];
                const partnerContacts = Object.values(obj.contacts);
                
                if(checked) {
                    // Contacts list cannot contain Self or a Selected Partner
                    availableContacts.forEach((item:any, index:number, arr:any) => {
                        if(selPartnerEmails.indexOf(item.contactEmail) < 0 && item.contactEmail != authorizedMember.memberEmail) newContacts.push(item);
                    });
                    
                    // Partner's Contacts cannot contain Self (primary user) or duplicates of Contacts
                    partnerContacts.forEach((item:any, index:number, arr:any) => {
                        if(selPartnerEmails.indexOf(item.contactEmail) < 0 && 
                            contactEmails.indexOf(item.contactEmail) < 0 && 
                            item.contactEmail != authorizedMember.memberEmail 
                            ) newContacts.push(item);
                    });
                } else {
                    // Remove Partner's Contacts
                    newContacts = availableContacts.filter( function( item: any ) {
                        return !partnerContacts.some(obj => isEqual(obj, item));
                    } );
                   
                    // Re-add Partner as Contact if not selected
                    let reAddContacts = contacts.filter( function( item: any ) {
                        return !availableContacts.some((obj:any) => isEqual(obj, item));
                    } );

                    reAddContacts.forEach((item: any, index:number, arr:any) => {
                        newContacts.push(item);
                    });
                    
                    // Contacts list cannot contain Self or a Selected Partner
                    const newContactsTemp = [...newContacts];
                    newContacts = [];
                    newContactsTemp.forEach((item:any, index:number, arr:any) => {
                        if(selPartnerEmails.indexOf(item.contactEmail) < 0 && item.contactEmail != authorizedMember.memberEmail) newContacts.push(item);
                    });
                }

                let newChecked = [...checkedContacts];
                partnerContacts.forEach((item:any, index:number, arr:any) => {
                    if(item.contactAlwaysUse == '1') newChecked.push(item.contactToken);                    
                }); 
                setCheckedContacts(newChecked);

                // Re-sort and set availableContacts
                newContacts.sort((a: any, b: any) => (a.contactLastName > b.contactLastName) ? 1 : ((b.contactLastName > a.contactLastName) ? -1 : 0))
                setAvailableContacts(newContacts);

                setMadeChanges(true);

            } else {
                setLoading(false);
                showToast({
                    message: 'Response Error.',
                    duration: 3000,
                    color: 'danger',
                    position: 'bottom'
                });
            }
        } catch(error) {
            setLoading(false);
            showToast({
                message: 'Connection Error 4: ' + error + '.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        }
        
    };


    //
    // Remove all Partners and associated objects
    //
    const removePartnerObjects = async () => {                
        setSelectedPartnerTokens([]);
        setSelectedPartnerEmails([]);
        setAvailableKids(kids);
        setAvailablePets(pets);
        setVehiclesAll(vehicles);
        setVehiclesStart(vehicles);
        setVehiclesEnroute(vehicles);
        setVehiclesEnd(vehicles);
        setSelectedVehiclesStart([]);
        setSelectedVehiclesEnroute([]);
        setSelectedVehiclesEnd([]);
        setAvailableContacts(contacts);

        setMadeChanges(true);
    };


    //
    // Handle Contact selection 
    //
    const handleContactSelection = (e: CustomEvent, contactToken: string) => {
        const isChecked = e.detail.checked;
      
        setCheckedContacts((prevCheckedContacts: any[]) => {
          // Add or remove the contact token based on the checkbox status
          return isChecked
            ? [...prevCheckedContacts, contactToken]
            : prevCheckedContacts.filter((token) => token !== contactToken);
        });

        setMadeChanges(true);
        validateForm();
    };      


    //
    // Handle Vehicle selection
    //
    const handleVehicleSelect = async (e: any) => {

        const vt = e.detail.value; 
        const checked = e.detail.checked;
        const id = e.target.id;
        
        let selVehiclesStart = selectedVehiclesStart;
        let selVehiclesEnroute = selectedVehiclesEnroute;
        let selVehiclesEnd = selectedVehiclesEnd;

        let newVehiclesStart: any = [];
        let newVehiclesEnroute: any = [];
        let newVehiclesEnd: any = [];
        
        switch(id) {
            case 'vehicleTokensStart':
                
                // Keep track of selected vehiclesStart
                if(checked) {
                    selVehiclesStart.push(vt);
                } else {
                    const tokenIndex = selVehiclesStart.indexOf(vt);
                    const xT = selVehiclesStart.splice(tokenIndex, 1);
                }
                setSelectedVehiclesStart(selVehiclesStart);    

                break;

            case 'vehicleTokensEnroute':
                
                // Keep track of selected vehiclesEnroute
                if(checked) {
                    selVehiclesEnroute.push(vt);
                } else {
                    const tokenIndex = selVehiclesEnroute.indexOf(vt);
                    const xT = selVehiclesEnroute.splice(tokenIndex, 1);
                }
                setSelectedVehiclesEnroute(selVehiclesEnroute);    

                break;

            case 'vehicleTokensEnd':
                
                // Keep track of selected vehiclesEnd
                if(checked) {
                    selVehiclesEnd.push(vt);
                } else {
                    const tokenIndex = selVehiclesEnd.indexOf(vt);
                    const xT = selVehiclesEnd.splice(tokenIndex, 1);
                }
                setSelectedVehiclesEnd(selVehiclesEnd);    

                break;
        }

        vehiclesAll.forEach((item:any, index:number, arr:any) => {
            if(selVehiclesStart.indexOf(item.vehicleToken) >= 0 || (selVehiclesEnroute.indexOf(item.vehicleToken) < 0 && selVehiclesEnd.indexOf(item.vehicleToken) < 0)) newVehiclesStart.push(item);
        });
        // Re-sort and set
        newVehiclesStart.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
        setVehiclesStart(newVehiclesStart);

        vehiclesAll.forEach((item:any, index:number, arr:any) => {
            if(selVehiclesEnroute.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0)) newVehiclesEnroute.push(item);
        });
        newVehiclesEnroute.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
        setVehiclesEnroute(newVehiclesEnroute);

        vehiclesAll.forEach((item:any, index:number, arr:any) => {
            if(selVehiclesEnd.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0)) newVehiclesEnd.push(item);
        });
        newVehiclesEnd.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
        setVehiclesEnd(newVehiclesEnd);   
        
        setMadeChanges(true);
         
    };

    
    //
    // Get Equipment
    //

    const getEquipment = async (mt:string) => {
        try {
          const formData = new FormData();
          formData.append('mt', mt);
          const response = await fetch('https://api.besolowise.com/equipment/get/', {
              method: 'POST',
              credentials: 'include',
              body: formData
          });

          if(response.ok) {   
              const obj = await response.json();
              
              if(obj) {
                  setEquipment(() => obj);
                  return true;
              } else {
                  showToast({
                      message: 'Data Error',
                      duration: 1000,
                      color: 'danger',
                      position: 'bottom'
                  });
              }
          } else {
              showToast({
                  message: 'Response Error',
                  duration: 1000,
                  color: 'danger',
                  position: 'bottom'
              });
          }
      } catch(error) {
          showToast({
              message: 'No Connection',
              duration: 2000,
              color: 'danger',
              position: 'bottom'
          });
      } 
    };
    
    
    const DSTChip = (dst: boolean) => {  
        //console.log(dst);      
        if(dst) return <IonText color={'warning'} slot='end'><b>DST</b></IonText>
        else return <IonText color={'dark'} slot='end'><b>Standard Time</b></IonText>
    };  


    //
    // Handle change of Timer Name
    //
    const handleTimerNameChange = (e: CustomEvent) => {
        setTimerName(e.detail.value);
        setMadeChanges(true);
    };
 

    //
    // Validate the form
    //
    const validateForm = () => {
        const place = placeRef.current !== undefined && placeRef.current !== null ? placeRef.current.value : '';
        const route = routeRef.current !== undefined && routeRef.current !== null ? routeRef.current.value : '';
        const times = validateTimes();
        
        const disable = ((place.length < 2 && route.length < 2) ||
                          times === false ||
                          checkedContacts.length < 1);
        setDisableSubmit(disable);
    };


    //
    // Initiate the submit process
    //
    const initSubmit = () => {
        if (formRef.current) {
            formRef.current.dispatchEvent(
                new Event("submit", { cancelable: true, bubbles: true })
            );
        }
    };
     

    //
    // Update the Timer
    //
    const updateTimer = async (e: any) => {
        //console.log(e);
        e.preventDefault();

        //stopCountdown();
        await present('Updating Timer...');
        const form = e.target; 
        const formName = form.name;

        const btns = document.querySelectorAll<HTMLInputElement>('#timerForm input[type="submit"]');
        btns.forEach(button => {
            button.disabled = true;
            button.innerHTML = 'Saving...';
        });

        const formData = new FormData(form);
        formData.append('token', token);
        formData.append('mt', authKey.mt);
        const apiURI = 'https://api.besolowise.com/timers/update/';
        try {
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                //console.log(obj);
                btns.forEach(button => {
                    button.disabled = false;
                    button.innerHTML = 'Save';
                });            
                
                if(obj.success) {
                    stopCountdown();
                    setMadeChanges(false);
                    dismiss();
                    router.push('/account/timer/view/' + obj.tt, 'back'); 
                    //getTimer(token);
                    /*showToast({
                        message: obj.message,
                        duration: 2500,
                        color: 'success',
                    });*/
                }

                if(!obj.success) {
                    dismiss();
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
            } else {
                btns.forEach(button => {
                    button.disabled = false;
                    button.innerHTML = 'Save';
                });
                dismiss();
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            dismiss();
            showToast({
                message: 'Connection Error 5: Couldn\'t update this timer. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        }       
    };
 

    const nl2br = (str: string) => {
        if (typeof str === 'undefined' || str === null) return '';
        let breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    };

    const typeText = (s: string) => {
        switch(s) {
            case 'ONE-WAY': return 'One-way'
            case 'LOOP': return 'Loop'       
            default:  return 'Unknown'
        }
    };

    const categoryText = (s: string) => {
        switch(s) {
            case '1': return 'Air'
            case '2': return 'Road'
            case '3': return 'Trail'
            case '4': return 'Water'           
            default:  return 'Unknown'
        }
    };
    
    const statusChip = (s: string) => {
        switch(s) {
            case '0': return <IonChip color={'dark'}><IonIcon icon={timerOutline} className='ion-margin-end'></IonIcon> Future</IonChip>
            case '1': return <IonChip color={'secondary'}><IonIcon icon={caretForwardCircleOutline} className='ion-margin-end'></IonIcon> Active</IonChip>
            case '2': return <IonChip color={'success'}><IonIcon icon={checkmarkCircleOutline} className='ion-margin-end'></IonIcon> Checked-In</IonChip>
            case '3': return <IonChip color={'warning'}><IonIcon icon={alarmOutline} className='ion-margin-end'></IonIcon> Over-Due</IonChip>
            case '4': return <IonChip color={'danger'}><IonIcon icon={alertCircleOutline} className='ion-margin-end'></IonIcon> ALERT</IonChip>           
            default:  return <IonChip color={'warning'}><IonIcon icon={helpCircleOutline} className='ion-margin-end'></IonIcon> Unknown</IonChip>
        }
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink={`/account/timer/view/${timer.token}`}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
                
                <IonToolbar className='ion-text-center' color={'success'}>
                    <p className='ion-no-margin'>EDIT MODE</p>
                    <div className='ion-text-center'>
                        <IonButton className='edit-button' fill='outline' routerDirection='back' routerLink={`/account/timer/view/${timer.token}`}>Cancel</IonButton>
                        <IonButton className='edit-button' fill='outline' onClick={initSubmit} disabled={!madeChanges}>Save Changes</IonButton>
                    </div>
                </IonToolbar>
                
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='TimerContent' ref={contentRef}>      
                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeMd='8'>
                            <h1>
                                <IonIcon className='m-hide' color={'secondary'} icon={alarmOutline}></IonIcon>
                                {timer.name}<br /><span>One-time Timer</span>
                            </h1>                            
                        </IonCol>
                        <IonCol className='ion-text-right' size='12' sizeMd='4'>
                            {loading 
                                ? <h1><IonSkeletonText animated={true} style={{ width: '35%', margin: '0 auto' }}></IonSkeletonText></h1>
                                : <>
                                   {statusChip(timer.status)}
                                  </>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>
                
                {(loading
                    ? (<p className='ion-text-center'>Loading<br /><IonSpinner className='ion-margin-top' name="crescent"></IonSpinner></p>)
                    : (<form ref={formRef} id='timerForm' name='timerForm' onSubmit={updateTimer}>
                        <IonCard>
                            <IonCardContent>                            
                                <IonGrid>                                
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>Timer Name</b></IonLabel>
                                        </IonCol>
                                        <IonCol size='12'>
                                            <IonInput 
                                                autocapitalize='sentences' 
                                                clearInput={true}
                                                counter 
                                                fill='outline' 
                                                name='timerName' 
                                                onIonChange={handleTimerNameChange}
                                                placeholder='' 
                                                type='text' 
                                                value={timerName} 
                                                maxlength={50}></IonInput>  
                                        </IonCol>                                  
                                    </IonRow>
                                </IonGrid>
                            </IonCardContent>
                        </IonCard>

                        <IonCard>
                            <IonCardContent id='when'>                            
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <h2><IonText color={'tertiary'}>When?</IonText></h2> 
                                            <IonLabel color={'dark'}><b>When are the dates and times this Timer will start and end?</b></IonLabel><br />
                                            <IonText><IonIcon color={'warning'} icon={warningOutline}></IonIcon> <em>At the Check-in time, please remember that you must be in a location that has an internet or cellular connection.</em></IonText>
                                        </IonCol>    
                                          
                                        <IonCol className='ion-margin-top ion-text-center' size='12' sizeSm='6'>
                                            <IonLabel color={'dark'}><b>Starting Date & Time</b> <em className='required'>Required</em></IonLabel>
                                            <IonRow className='ion-margin-bottom ion-margin-top'>
                                                <IonCol sizeXs='12'>
                                                    <IonDatetimeButton datetime="start-datetime" id='start-datetime-button'></IonDatetimeButton>
                                                    <IonModal keepContentsMounted={true}>
                                                        <IonDatetime 
                                                            id="start-datetime"
                                                            color={'tertiary'}
                                                            minuteValues='0,15,30,45'
                                                            name='timerStartTime'
                                                            preferWheel={false}
                                                            showDefaultButtons={true}
                                                            value={timerStartTimeISO}
                                                            onIonChange={handleStartTimeISOChange}
                                                        ></IonDatetime>
                                                    </IonModal>
                                                </IonCol>                                            
                                            </IonRow>
                                        </IonCol> 
                                    
                                        <IonCol className='ion-margin-top ion-text-center' size='12' sizeSm='6'>
                                            <IonLabel color={'dark'}><b>Check-in Date & Time</b> <em className='required'>Required</em></IonLabel>
                                            <IonRow className='ion-margin-top'>
                                                <IonCol sizeXs='12'>                                                
                                                    <IonDatetimeButton datetime="end-datetime" id='end-datetime-button'></IonDatetimeButton>
                                                    <IonModal keepContentsMounted={true}>
                                                        <IonDatetime 
                                                            id="end-datetime"
                                                            color={'tertiary'}
                                                            minuteValues='0,15,30,45'
                                                            name='timerEndTime'
                                                            preferWheel={false}
                                                            showDefaultButtons={true}
                                                            value={timerEndTimeISO}
                                                            onIonChange={handleEndTimeISOChange}
                                                        ></IonDatetime>
                                                    </IonModal>
                                                </IonCol>                                            
                                            </IonRow>
                                        </IonCol>
                                        
                                        {/*<IonCol className='ion-padding ion-text-center' sizeXs='12'>
                                            <TimerProgressBar 
                                                token={token} 
                                                getTimer={getTimer} 
                                                status={timer.status} 
                                                now={now}
                                                startTime={startTime} 
                                                endTime={endTime} 
                                                timerTimezone={timerTimezone} 
                                                todayIsDST={todayIsDST} 
                                                parent={'edit'} />
                                        </IonCol>*/}                          
                                    </IonRow>
                                            
                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol size='12' sizeSm='6'>
                                            <IonLabel color={'dark'}><b>Duration:</b></IonLabel> <IonChip outline={true}><b>{timerDuration}</b></IonChip>
                                        </IonCol>
                                    </IonRow>

                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol size='12' sizeSm='6'>
                                            <IonLabel color={'dark'}><b>Time Zone of the check-in location</b></IonLabel>                                      
                                            <IonSelect 
                                                className='ion-margin-top' 
                                                fill='outline' 
                                                labelPlacement='stacked' 
                                                name='timerTimezone' 
                                                onIonChange={handleTimezoneChange}
                                                placeholder='Select a Timezone' 
                                                value={timerTimezone}>
                                                {timezonesIANA.map((zone: any, index: number) => (
                                                    <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                                ))}                                            
                                            </IonSelect>
                                        </IonCol>   
                                    </IonRow>    

                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>After the check-in time, would you like to add some additional time before SoloWise sends alarm notifications to your emergency contact(s)?</b></IonLabel>
                                        </IonCol>                                    
                                        <IonCol size='12' sizeSm='6'>
                                            <IonSelect fill='outline' label='Alarm Delay Period' labelPlacement='stacked' name='timerAlarmDelay' onIonChange={handleAlarmDelayChange} value={alarmDelay === undefined ? '0' : alarmDelay}>
                                                <IonSelectOption value='0.00'>No Delay</IonSelectOption>
                                                <IonSelectOption value='0.25'>15 minutes</IonSelectOption>
                                                <IonSelectOption value='0.50'>30 minutes</IonSelectOption>
                                                <IonSelectOption value='1'>1 hour</IonSelectOption>
                                                <IonSelectOption value='2'>2 hours</IonSelectOption>
                                                <IonSelectOption value='3'>3 hours</IonSelectOption>
                                                <IonSelectOption value='6'>6 hours</IonSelectOption>
                                                <IonSelectOption value='12'>12 hours</IonSelectOption>
                                                <IonSelectOption value='24'>24 hours</IonSelectOption>
                                            </IonSelect>                
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonCardContent>
                        </IonCard>

                        <IonCard>
                            <IonCardContent id='where'>                            
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <h2><IonText color={'tertiary'}>Where?</IonText></h2>
                                        </IonCol>                       
                                    </IonRow>

                                    <IonRow>
                                        <IonCol size='12'>
                                            <input name='timerType' type='hidden' value={typeSetting !== undefined ? typeSetting : ''} />

                                            { typeSetting == 'STATIONARY' &&
                                                (<IonRow>
                                                    <IonCol size='12'>
                                                        <IonLabel color={'dark'}><b>Where are you staying?</b> <em className='required'>Required</em></IonLabel>
                                                    </IonCol>
                                                    <IonCol size='12'> 
                                                        <IonSelect fill='outline' label='Saved SoloWise Places' labelPlacement='stacked' name='placeToken' 
                                                        onIonChange={(e) => {
                                                            getTimezone(e);
                                                            setMadeChanges(true);
                                                            validateForm();
                                                            setPlace(e.detail.value);
                                                        }} 
                                                        placeholder='Select a Saved Place'
                                                        ref={placeRef}
                                                        value={place}>
                                                            {places
                                                                .filter((p: any) => p.placeSaved == '1' || p.placeToken == place)
                                                                .map((place:any, index:any) => (
                                                                <IonSelectOption key={index} value={place.placeToken}>{place.placeName}</IonSelectOption>
                                                            ))
                                                        }                                            
                                                        </IonSelect>                       
                                                    </IonCol>
                                                </IonRow>)
                                            }

                                            { typeSetting == 'MOBILE' &&
                                                (<IonRow>
                                                    <IonCol size='12'>
                                                        <IonLabel color={'dark'}><b>Where are you going?</b> <em className='required'>Required</em></IonLabel>
                                                    </IonCol>
                                                    <IonCol size='12'>
                                                        <IonSelect fill='outline' label='Saved SoloWise Routes' labelPlacement='stacked' name='routeToken'
                                                        onIonChange={(e) => {
                                                            getTimezone(e);
                                                            setMadeChanges(true);
                                                            validateForm();
                                                            setRoute(e.detail.value);
                                                        }} 
                                                        placeholder='Select a Saved Route' 
                                                        ref={routeRef}
                                                        value={route}>
                                                            {routes
                                                                .filter((rte: any) => rte.isSaved == '1' || rte.token === route)
                                                                .map((rte:any, index:any) => (                                 
                                                                <IonSelectOption key={index} value={rte.token}>{rte.name}</IonSelectOption>
                                                                )
                                                              )
                                                            }                                            
                                                        </IonSelect>                       
                                                    </IonCol>                                               
                                                </IonRow>)
                                            }
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonCardContent>
                        </IonCard>

                        <IonCard>
                            <IonCardContent id='who'>                            
                                <IonGrid> 
                                    <IonRow>
                                        <IonCol size='12'>
                                            <h2><IonText color={'tertiary'}>Who?</IonText></h2>
                                        </IonCol>
                                    </IonRow>
                                    
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>SoloWise Contacts</b></IonLabel>
                                        </IonCol>
                                        <IonCol size='12'> 
                                            <IonRow>
                                                {availableContacts !== undefined && availableContacts.length > 0
                                                    ? (availableContacts.map((contact:any, index:number) => (
                                                        <IonCol key={index} size='12' sizeSm='6'>
                                                            <IonCheckbox 
                                                                color={'secondary'}
                                                                checked={checkedContacts.includes(contact.contactToken)}
                                                                key={index}
                                                                labelPlacement="end"
                                                                name='contactTokens[]'
                                                                onIonChange={(e) => handleContactSelection(e, contact.contactToken)}
                                                                value={contact.contactToken}
                                                                >
                                                                {contact.contactFirstName} {contact.contactLastName}<br/>{contact.contactEmail}
                                                            </IonCheckbox>
                                                        </IonCol>)))
                                                    : (<p>No options available.</p>)                                            
                                                } 
                                            </IonRow>
                                        </IonCol>
                                    </IonRow>
                                    
                                    { level?.memberLevelID > 1 &&
                                      <>  
                                        <IonRow className='ion-margin-top'>
                                            <IonCol size='12' sizeSm='6'>
                                                <IonLabel color={'dark'}><b>How many other people are with you?</b></IonLabel> 
                                                <IonSelect className='ion-margin-top' fill='outline' label='Number of other people' labelPlacement='stacked' name='partySize' onIonChange={handlePartySizeChange} placeholder='Number of other people' value={partySize}>
                                                    <IonSelectOption value='0'>No one, I'm solo.</IonSelectOption>
                                                    <IonSelectOption value='1'>1</IonSelectOption>
                                                    <IonSelectOption value='2'>2</IonSelectOption>
                                                    <IonSelectOption value='3'>3</IonSelectOption>
                                                    <IonSelectOption value='4'>4</IonSelectOption>
                                                    <IonSelectOption value='5'>5</IonSelectOption>
                                                    <IonSelectOption value='6'>6</IonSelectOption>
                                                    <IonSelectOption value='7'>7</IonSelectOption>
                                                    <IonSelectOption value='8'>8</IonSelectOption>
                                                    <IonSelectOption value='9'>9</IonSelectOption>
                                                    <IonSelectOption value='10'>10</IonSelectOption>
                                                </IonSelect>                       
                                            </IonCol>
                                        </IonRow>

                                        { settings.menuPartners == '1' && partySize != '0' &&
                                            (<IonRow className='ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>SoloWise Partners</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        {activePartners !== undefined && activePartners.length > 0
                                                            ? (activePartners.map((partner:any, index:number) => (
                                                                <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                                    <IonCheckbox color={'secondary'} checked={selectedPartnerTokens.indexOf(partner.partnerToken) >= 0} labelPlacement="end" name='partnerTokens[]' key={index} onIonChange={getPartnerObjects} value={partner.partnerToken}>{partner.firstName} {partner.lastName}</IonCheckbox>
                                                                </IonCol>)))
                                                            : (<p>No options available.</p>)                                            
                                                        } 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>)
                                        }

                                        { partySize != '0' &&
                                            (<IonRow className='ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>Unregistered Partners</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        <IonTextarea autoGrow={true} fill='outline' name='partnerText' onIonChange={handlePartnerTextChange} placeholder='You can list the names and information of others with you.' value={partnerText}></IonTextarea> 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>)
                                        }

                                        { settings.menuKids == '1' && partySize != '0' &&
                                            (<IonRow className='ion-margin-bottom ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>SoloWise Kids</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        {availableKids !== undefined && availableKids.length > 0
                                                            ? (availableKids.map((kid:any, index:number) => (
                                                                <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                                    <IonCheckbox color={'secondary'} checked={selectedKids.indexOf(kid.kidToken) >= 0} labelPlacement="end" name='kidTokens[]' onIonChange={handleKidSelect} key={index} value={kid.kidToken}>{kid.kidFirstName} {kid.kidLastName}</IonCheckbox>
                                                                </IonCol>)))
                                                            : (<p>No options available.</p>)                                            
                                                        } 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>)
                                        }
                                      </>
                                    }
  
                                </IonGrid>
                            </IonCardContent>
                        </IonCard>

                        <IonCard>
                            <IonCardContent id='what'>                            
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <h2><IonText color={'tertiary'}>What?</IonText></h2>
                                        </IonCol>
                                    </IonRow>
                                    
                                    <IonRow className='ion-margin-bottom'>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>What will you be doing?</b></IonLabel>
                                            <IonText><p>Describe any pertinent activities, such as hiking, socializing, meeting a client, running errands, etc.</p></IonText>
                                        </IonCol>
                                        <IonCol size='12'> 
                                            <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='timerActivity' onIonChange={handleActivityChange} placeholder='' value={activity}></IonTextarea>
                                        </IonCol>
                                    </IonRow>                                    

                                    { level?.memberLevelID > 1 && settings?.menuPets == '1' &&
                                        (<IonRow className='ion-margin-bottom'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>SoloWise Pets</b></IonLabel>
                                            </IonCol>
                                            <IonCol size='12'> 
                                                <IonRow>
                                                    {availablePets !== undefined && availablePets.length > 0
                                                        ? (availablePets.map((pet:any, index:number) => (
                                                            <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                                <IonCheckbox color={'secondary'} checked={selectedPets.indexOf(pet.petToken) >= 0} labelPlacement="end" name='petTokens[]' onIonChange={handlePetSelect} key={index} value={pet.petToken}>{pet.petName}</IonCheckbox>
                                                            </IonCol>)))
                                                        : (<p>No options available.</p>)                                            
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>)
                                    }

                                    { settings?.menuVehicles == '1' && profiles?.vehicles >= 1 &&
                                        (<>                                        
                                         <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>SoloWise Vehicles parked at { typeSetting == '' || typeSetting == 'STATIONARY' ? 'this' : 'the Starting' } Place</b></IonLabel>
                                            </IonCol>
                                            <IonCol size='12'> 
                                                <IonRow>
                                                    {vehiclesStart !== undefined && vehiclesStart.length > 0
                                                        ? (vehiclesStart.map((vehicle:any, index:number) => (
                                                            <IonCol key={index} size='12' sizeSm='6'>
                                                                <IonCheckbox 
                                                                    color={'secondary'}
                                                                    checked={selectedVehiclesStart.indexOf(vehicle.vehicleToken) >= 0}
                                                                    id='vehicleTokensStart'
                                                                    labelPlacement="end" 
                                                                    name='vehicleTokensStart[]' 
                                                                    key={index} 
                                                                    onIonChange={handleVehicleSelect} 
                                                                    value={vehicle.vehicleToken}>{vehicle.vehicleYear} {vehicle.vehicleModel}</IonCheckbox>
                                                            </IonCol>)))
                                                        : (<p>No options available.</p>)                                            
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>
                                        
                                        { routeType != '' &&
                                            (<IonRow className='ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>SoloWise Vehicles driven or parked somewhere along the way</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        {vehiclesEnroute !== undefined && vehiclesEnroute.length > 0
                                                            ? (vehiclesEnroute.map((vehicle:any, index:number) => (
                                                                <IonCol key={index} size='12' sizeSm='6'>
                                                                    <IonCheckbox 
                                                                        color={'secondary'}
                                                                        checked={selectedVehiclesEnroute.indexOf(vehicle.vehicleToken) >= 0}
                                                                        id='vehicleTokensEnroute'
                                                                        labelPlacement="end" 
                                                                        name='vehicleTokensEnroute[]' 
                                                                        key={index} 
                                                                        onIonChange={handleVehicleSelect} 
                                                                        value={vehicle.vehicleToken}>{vehicle.vehicleYear} {vehicle.vehicleModel}</IonCheckbox>
                                                                </IonCol>)))
                                                            : (<p>No options available.</p>)                                            
                                                        } 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>)
                                        }

                                        { routeType == 'ONE-WAY' &&
                                            (<IonRow className='ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>SoloWise Vehicles parked at the Ending Place?</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        {vehiclesEnd !== undefined && vehiclesEnd.length > 0
                                                            ? (vehiclesEnd.map((vehicle:any, index:number) => (
                                                                <IonCol key={index} size='12' sizeSm='6'>
                                                                    <IonCheckbox 
                                                                        color={'secondary'}
                                                                        checked={selectedVehiclesEnd.indexOf(vehicle.vehicleToken) >= 0}
                                                                        id='vehicleTokensEnd'
                                                                        labelPlacement="end" 
                                                                        name='vehicleTokensEnd[]' 
                                                                        key={index} 
                                                                        onIonChange={handleVehicleSelect} 
                                                                        value={vehicle.vehicleToken}>{vehicle.vehicleYear} {vehicle.vehicleModel}</IonCheckbox>
                                                                </IonCol>)))
                                                            : (<p>No options available.</p>)                                            
                                                        } 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>)
                                        }
                                        </>)
                                    }
    
                                    <IonRow className='ion-margin-top'>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>What safety / survival equipment will you have with you?</b></IonLabel>
                                        </IonCol>
                                        <IonCol size='12'>                                         
                                                
                                            <IonAccordionGroup value={checkedEquipment.length >= 1 ? 'equipment' : ''}>                                        
                                                <IonAccordion value='equipment'>
                                                    <IonItem slot="header" color="light">
                                                        <IonLabel>Equipment List</IonLabel>
                                                    </IonItem>
                                                    <div slot="content">
                                                        <IonCard>
                                                            <IonCardContent>
                                                                <IonRow>
                                                                {!loading
                                                                    ? (equipment !== undefined && equipment.length > 0
                                                                        ? (equipment.map((eq:any, index:any) => (
                                                                            <IonCol key={index} size='12' sizeSm='6'>
                                                                                <IonCheckbox 
                                                                                    color={'secondary'}
                                                                                    checked={checkedEquipment.indexOf(eq.equipmentID.toString()) >= 0}
                                                                                    key={index}
                                                                                    labelPlacement="end"
                                                                                    name='equipmentIDs[]'
                                                                                    onIonChange={(e) => handleEquipmentSelect(e, eq.equipmentID)}
                                                                                    value={eq.equipmentID}
                                                                                    >
                                                                                    {eq.equipmentName}
                                                                                </IonCheckbox>
                                                                            </IonCol>)))
                                                                        : (<>
                                                                            <p>Loading Equipment List...</p>   
                                                                            </>)   
                                                                    )   
                                                                    : <p>No options available.</p>
                                                                }
                                                                </IonRow>
                                                            </IonCardContent>
                                                        </IonCard>                            
                                                    </div>
                                                </IonAccordion> 
                                            </IonAccordionGroup>
                                            
                                        </IonCol>
                                    </IonRow>
                                    
                                    <IonRow className='ion-margin-top'>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>Provide Specific Instructions for Your Emergency Contacts</b></IonLabel>
                                            <IonText><p>Include the name and phone number of the agency or angencies your emergency contact(s) should call. This could be your local police, the search and rescue team in your area, etc.</p></IonText>
                                        </IonCol>
                                        <IonCol size='12'>
                                            <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='timerNotes' placeholder='' value={timer.notes}></IonTextarea>                               
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>                                                     
                            </IonCardContent>
                        </IonCard>

                        <IonCard>
                            <IonCardContent>                            
                                <IonGrid> 
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonButton color={disableSubmit ? 'primary' : 'secondary'} expand='block' id='timerFormSubmit' type='submit' disabled={disableSubmit}>Save Changes</IonButton>                        
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonCardContent>
                        </IonCard>
                    </form>)
                )}
                
            </IonContent>
        </IonPage>
    );
};

export default TimerEdit;